<template>
  <b-container fluid>
    <backlink/>
    <h1>Environnements de stockage</h1>

    <AdminTable :config="config" :options="options"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "StorageEnvironmentList",
  components: {
    AdminTable
  },
  data() {
    return {
      config: config
    };
  },
  computed: {
    options: function() {
      return {
        storage_type_options: this.$store.getters[
          "storage_type/getAll"
        ].selectOptions("id", "name"),
        warehouse_options: this.$store.getters[
          "warehouse/getAll"
        ].selectOptions("id", ["internal_code", " - ", "name"])
      };
    }
  },
  mounted() {
    this.$store.dispatch("storage_type/getAll");
    this.$store.dispatch("warehouse/getAll");
  }
};
</script>


// WEBPACK FOOTER //
// src/components/StorageEnvironment/StorageEnvironmentList.vue